import React from "react";

import { OptionsType, ResponseType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";
import { CmNewsBody, CmNewsDetails, CmNewsListItem } from "types/api/cmNews";

function useCmNewsApi() {
    const { get, del, post, put } = useHttpManaged();

    const getAllCmNews = React.useCallback(
        (queryParams: AdvancedListRequest, options?: OptionsType): ResponseType<ListResponse<CmNewsListItem>> => {
            return get<undefined, AdvancedListRequest, ListResponse<CmNewsListItem>>({
                url: "/cm-news",
                queryParams: queryParams,
                options: options,
            });
        },
        [get],
    );

    const getOneCmNews = React.useCallback(
        (pathParams: PathParamsWithId, options?: OptionsType): ResponseType<CmNewsDetails> => {
            return get<PathParamsWithId, undefined, CmNewsDetails>({
                url: "/cm-news/:id",
                pathParams: pathParams,
                options: options,
            });
        },
        [get],
    );

    const createCmNews = React.useCallback(
        (body: CmNewsBody, options?: OptionsType): ResponseType<ResponseWithId> => {
            return post<undefined, undefined, CmNewsBody, ResponseWithId>({
                url: "/cm-news",
                body: body,
                options: options,
            });
        },
        [post],
    );

    const updateCmNews = React.useCallback(
        (pathParams: PathParamsWithId, body: CmNewsBody, options?: OptionsType): ResponseType<null> => {
            return put<PathParamsWithId, undefined, CmNewsBody, null>({
                url: "/cm-news/:id",
                pathParams: pathParams,
                body: body,
                options: options,
            });
        },
        [put],
    );

    const deleteCmNews = React.useCallback(
        (pathParams: PathParamsWithId, options?: OptionsType): ResponseType<null> => {
            return del<PathParamsWithId, undefined, null>({
                url: "/cm-news/:id",
                pathParams: pathParams,
                options: options,
            });
        },
        [del],
    );

    return {
        getAllCmNews,
        getOneCmNews,
        createCmNews,
        updateCmNews,
        deleteCmNews,
    };
}

export default useCmNewsApi;
